import type { FacetKey } from "@/lib/facets";
import type { Lang } from "@/content/guides/types";
import type { FacetEditorial, FacetEditorialCopy, FacetEditorialMap } from "./types";
import { SHAPE_EDITORIAL } from "./shapes";
import { COLOR_EDITORIAL } from "./colors";
import { MATERIAL_EDITORIAL } from "./materials";
import { GENDER_EDITORIAL, SIZE_EDITORIAL } from "./genders";

export type { FacetEditorial, FacetEditorialCopy } from "./types";

const REGISTRY: Partial<Record<FacetKey, FacetEditorialMap>> = {
  shape: SHAPE_EDITORIAL,
  color: COLOR_EDITORIAL,
  material: MATERIAL_EDITORIAL,
  gender: GENDER_EDITORIAL,
  size: SIZE_EDITORIAL,
};

/** Contenu éditorial dédié à une valeur de facette, ou null (fallback générique). */
export function getFacetEditorial(
  key: FacetKey | null | undefined,
  valueId: string | null | undefined,
): FacetEditorial | null {
  if (!key || !valueId) return null;
  return REGISTRY[key]?.[valueId] ?? null;
}

/** Bloc de copie dans la langue du marché. */
export function getFacetEditorialCopy(
  key: FacetKey | null | undefined,
  valueId: string | null | undefined,
  lang: Lang,
): FacetEditorialCopy | null {
  const entry = getFacetEditorial(key, valueId);
  return entry ? entry[lang] : null;
}
